var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZertifikate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 80,
    height: 80,
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    x: 57.5,
    y: 55.6,
    className: "st0",
    width: 40,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    x: 57.5,
    y: 85.6,
    className: "st0",
    width: 40,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    x: 57.5,
    y: 115.6,
    className: "st0",
    width: 40,
    height: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00488E",
    className: "st0",
    points: "142,49.1 135,42 118.5,58.5 112,52 105,59.1 118.5,72.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00488E",
    className: "st0",
    points: "142,79.1 135,72 118.5,88.5 112,82 105,89.1 118.5,102.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00488E",
    className: "st0",
    points: "142,109.1 135,102 118.5,118.5 112,112 105,119.1 118.5,132.6  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00488E",
    className: "st0",
    d: "M158.5,23.7c-25.3-5.1-86.5-5.1-116.8,0l-4.2,0.7v151.1l4.3,0.6c18.7,2.7,39.5,4.1,59.5,4.1 c10.9,0,21.6-0.4,31.5-1.3l1.6-0.1l1.2-1.1c12.6-10.8,24.9-23.8,25.5-24.4l1.4-1.4V24.5C162.5,24.5,158.5,23.7,158.5,23.7z  M47.5,166.7V32.9c28.9-4,79.8-4.1,105-0.1v107.1h-25.1v29.4C102.4,171,73.2,170.1,47.5,166.7L47.5,166.7z M137.4,162.7v-12.8h13.1 C147.5,152.9,142.7,157.7,137.4,162.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZertifikate);
export default __webpack_public_path__ + "static/media/zertifikate.8f91f8d9b1dde8ee351bb2363fb23922.svg";
export { ForwardRef as ReactComponent };